// STUDENT APP store-chats (code sync: dev-variant): listens only to the user's own chat (chats/<own uid>).
// The dev app copy listens to all chats for the admin chat panel.
import { defineStore } from 'pinia'
import { fbDatabase, fbAuth } from 'src/boot/firebase'
import { useUserStore } from './store-user'

export const useChatsStore = defineStore('chats', {
  state: () => ({
    chats: {},
    selectedChatId: null,
    chatsDownloaded: false,
    currentPath: '/',
    displayChats: false,
  }),

  actions: {
    fetchChats(forceReload = false) {
      if (this.chatsDownloaded && !forceReload) return


    let fbRef = fbDatabase.ref("chats/").orderByKey().equalTo(fbAuth.currentUser.uid).limitToFirst(1)

      fbRef.on('child_added', snapshot => {
        const chat = snapshot.val()
        this.chats[snapshot.key] = chat
      })

      fbRef.on('child_changed', snapshot => {
        const chat = snapshot.val()
        this.chats[snapshot.key] = chat
      })

      fbRef.on('child_removed', snapshot => {
        delete this.chats[snapshot.key]
      })

      // listeners attached: onUserFetched runs again on every profile change, do not add them twice
      this.chatsDownloaded = true
    },
  },

  getters: {
    userId() {
      return useUserStore().uid
    },
    getChats() {
      return this.chats
    },
    getSelectedChat() {
      return this.chats[this.userId]
    },
    getUnreadChats() {
      const finalList = {}

      Object.keys(this.getChats).forEach(chatId => {
        const chat = this.getChats[chatId]
        Object.keys(chat).forEach(messageId => {
          const message = chat[messageId]
          if (message.from !== this.userId && !message.seenBy?.[this.userId]) {
            finalList[messageId] = message
          }
        })
      })

      return finalList
    },
  },
})
